import React from 'react';
import LegalPage from '../../components/PublicSite/LegalPage';
import fetchStaticPage from '../../components/PublicSite/fetchStaticPage';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

// StaticPage id 5 ("Legal") — isinya Privacy Policy, identik dengan id 3 dan 4.
// Route lama merender privacy.md, yang isinya Lorem ipsum bawaan starter kit.
async function action() {
  await loadSiteCopy();
  const result = await fetchStaticPage(5);

  return {
    // metaTitle di DB adalah "Legal" — nama internal dashboard, bukan judul
    // halaman. Judul situs ditetapkan di sini.
    title: 'Privacy Notice — Bas Recovery',
    description: (result && result.metaDescription) || '',
    component: (
      <HeadLessLayout>
        <LegalPage result={result} current="/privacy" titleKey="legal.privacy.h1" />
      </HeadLessLayout>
    ),
  };
}

export default action;
